import MapController from './Controller/MapController';

window.initializeMaps = function () {
	MapController.initializeMaps();
};

//google.maps.event.addDomListener(window, 'load', initializeMaps);
